export enum SubmissionParamsKeys {
  SUBMISSION_ID = 'submissionId',
}
